export default "__VITE_PUBLIC_ASSET__af2325a8__"